// extracted by mini-css-extract-plugin
export var actions = "_u-0";
export var actionsContainer = "_u-6";
export var border = "_u-1";
export var childFullHeight = "_u-d";
export var collapse = "_u-2";
export var content = "_u-8";
export var contentChild = "_u-c";
export var fullscreen = "_u-a";
export var headerContainer = "_u-3";
export var headerRow = "_u-5";
export var hidePadding = "_u-9";
export var noScrollX = "_u-e";
export var noScrollY = "_u-f";
export var optOutTopPadding = "_u-b";
export var pagePadding = "_u-7";
export var profile = "_u-g";
export var profileContainer = "_u-h";
export var profileImage = "_u-i";
export var profileMain = "_u-j";
export var profileSubtitle = "_u-l";
export var profileTitle = "_u-k";
export var tabsWrapper = "_u-4";
export var title = "_u-m";